module.exports = __webpack_public_path__ + "marker-white.svg?b42cabe076ba87afd5380e211e6f3382";